module.exports = __webpack_public_path__ + "static/media/view_selection.f6b5eb98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindHeat/view_selection.png
// module id = 2520
// module chunks = 0